import { DEFAULT_VIEW, serpentineThresholdFor, type SceneView } from "../scene";
import type { LiquidUnits } from "../workspace/units";
import type { EditorState } from "./state";

/**
 * How the editor's state asks the scene to be drawn. The canvas and a still
 * export both build their scene through this, so an exported image is the
 * scene the designer is looking at, not a near copy of it (invariant 7).
 */
export function sceneViewFor(
  state: Pick<EditorState, "collapsed" | "grid" | "annotations" | "designKind">,
  preview: SceneView["preview"] = null,
  /** The design's display units (D49), where a workspace provides them. */
  units: LiquidUnits | null = null,
): SceneView {
  return {
    ...DEFAULT_VIEW,
    preview,
    ...(units ? { units } : {}),
    collapsed: state.collapsed,
    grid: { spacing: state.grid.spacing, visible: state.grid.visible },
    annotations: state.annotations,
    serpentineThreshold: serpentineThresholdFor(state.designKind),
  };
}
